import defaultUserThumbnail from '$img/thumbnails/default-user.jpg';

export function handleImageError(fallback: string = defaultUserThumbnail) {
	return (event: Event) => {
		const img = event.target as HTMLImageElement;
		if (img.src !== fallback) {
			img.src = fallback;
		}
	};
}
